import React, { createContext, useContext, useState } from 'react';

const MatrixContext = createContext();

export function MatrixProvider({ children }) {
  const [isTradeTrackerActive, setIsTradeTrackerActive] = useState(false);

  return (
    <MatrixContext.Provider value={{ isTradeTrackerActive, setIsTradeTrackerActive }}>
      {children}
    </MatrixContext.Provider>
  );
}

export function useMatrix() {
  const context = useContext(MatrixContext);
  if (!context) {
    throw new Error('useMatrix must be used within MatrixProvider');
  }
  return context;
}
